'use client'
import React, { useEffect, useState } from 'react';
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link';
import NavBarLanding from '@/components/NavBarLanding';
import Footer from '@/components/Footer';
import { SignFrom } from '@/components/Sign';
import { useRouter, useParams } from 'next/navigation';
import { posts } from '../blogPosts';
import { Post } from '../PostType';
import BlogLayoutTuto from './BlogLayoutTuto';
import BlogLayoutNews from './BlogLayoutNews';
import BlogMarkdown from './BlogMarkdown';

const BlogPost: React.FC = () => {
    const [signValue, setSignValue] = useState<string>('signup');
    const [toggleSignForm, setToggleSignForm] = useState<boolean>(false);
    const [post, setPost] = useState<Post>();
    const router = useRouter();
    const { blogId } = useParams() as { blogId: string };

    const getPost = () => {
        const id = Number(blogId);
        let post = posts.find((post) => post.id === id);
        setPost(post);
        if (!post) {
            throw new Response('Post Not Found', { status: 404 });
        }
    }

    useEffect(() => {
        getPost();
    }, [blogId])

    let LayoutComponent;
    if (post && post.type) {
        switch (post.type) {
            case 'markdown':
                LayoutComponent = BlogMarkdown;
                break;
            case 'tuto':
                LayoutComponent = BlogLayoutTuto;
                break;
            case 'news':
                LayoutComponent = BlogLayoutNews;
                break;
            default:
                LayoutComponent = null; // Une mise en page par défaut
        }
    }


    return (
        <>
            <Head>
                <title>Eurekia !</title>
                <meta name="description" content="Generated by webzh" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <main className="w-full items-center justify-center flex-col bg-main overflow-x-hidden relative gap-4 h-full">
                {
                    toggleSignForm ?

                        <div className='w-full sm:h-full h-screen flex justify-center items-center'>
                            <style global jsx>{`
    #__next {
        height:100vh;
        width:100vw;
        overflow:hidden
      }
`}</style>
                            <div onClick={() => setToggleSignForm(false)} className='z-50 w-full h-full fixed top-0 left-0 flex justify-center items-center backdrop-blur-md bg-black bg-opacity-10'>
                            </div>
                            <div className='z-[1000] fixed flex justify-center'>
                                <SignFrom signValue={signValue} />
                            </div>
                        </div>
                        : null
                }
                < NavBarLanding
                    signValue={signValue as string}
                    setSignValue={setSignValue}
                    toggleSignForm={toggleSignForm}
                    setToggleSignForm={setToggleSignForm}
                />
                <section className="w-full flex flex-col items-center h-auto pt-[120px]">
                    {
                        post &&
                        <>
                            {
                                LayoutComponent ? <LayoutComponent post={post} setToggleSignForm={setToggleSignForm} /> :
                                    <article className="max-w-2xl">
                                        <div className='relative'>
                                            <img src={post.imageUrl} alt={`Image for ${post.title}`} className="w-full object-cover rounded-sm" />
                                            <div className='absolute bottom-2 left-0 bg-black2/80 flex p-4 justify-start mr-2'>
                                                <h1 className="text-3xl font-bold my-2 ">{post.content.h1}</h1>
                                            </div>
                                        </div>
                                        <div className="px-6 py-4">
                                            <p className="text-gray-200 my-2">{post.content.intro}</p>
                                            {post.content && post.content.sections && post.content.sections.map((section, index) => (
                                                <div key={index} className="my-4">
                                                    <h2 className="text-2xl font-semibold">{section.h2}</h2>
                                                    <p className="text-gray-200">{section.paragraph}</p>
                                                </div>
                                            ))}
                                            <p className="text-gray-200 my-2">{post.content.conclusion}</p>
                                            <p onClick={() => setToggleSignForm(true)} className="text-blue-600 hover:text-blue-800 cursor-pointer">{post.content.callToAction}</p>
                                        </div>
                                        <div className="px-8 pt-4 pb-2">
                                            <div className="flex justify-between items-center flex-col sm:flex-row gap-4">
                                                <div className="flex gap-2 items-center text-sm text-gray-300">
                                                    {post.category.map((category) => (
                                                        <span key={category} className="bg-gray-200 rounded-full px-3 py-1 font-semibold text-brand">{category}</span>
                                                    ))}
                                                </div>
                                                <div className="text-sm text-gray-500">
                                                    <span className="font-medium">{post.author}</span>
                                                    <span className="mx-2">•</span>
                                                    <time dateTime={post.date}>{post.date}</time>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                            }
                        </>
                    }
                </section>
                <Footer />
            </main>
        </>
    );
};

export default BlogPost;